import React from 'react';
import { useTranslation } from 'react-i18next';

import SelectInputFieldControlled from 'components/layout/forms/SelectInputFieldControlled';
import TextInputField from 'components/layout/forms/TextInputField';
import translations from 'services/translations/translations';

import IVersion from '../IVersion';
import OfferText from './OfferText';

/**
 * The name and the offer text of the active alternative (version): what is printed in the
 * offer PDF. The editor has the width of the text in the PDF.
 */
const Version = ({
  activeVersionIndex,
  locked,
  offerText,
  onOfferTextChanged,
  setActiveVersionIndex,
  setVersions,
  versions,
}: {
  activeVersionIndex: number;
  locked: boolean;
  offerText: string;
  onOfferTextChanged: (value: string) => void;
  setActiveVersionIndex: (index: number) => void;
  setVersions: (versions: IVersion[]) => void;
  versions: IVersion[];
}): JSX.Element => {
  const { t } = useTranslation([translations.common, translations.offers]);

  const onVersionNameChange = (event: any) =>
    setVersions(
      versions.map((version, index) =>
        index === activeVersionIndex
          ? { ...version, name: event.target.value }
          : version
      )
    );

  return (
    <>
      {/* The alternative can be changed also here, beside its name (as at the top) */}
      <div className="version-name-row">
        <SelectInputFieldControlled
          formGroupClassName="version-name-row-select"
          id="offer-product-version-select-text"
          label={t(`${translations.calculationWindow}:Version`)}
          name="offer-product-version-select-text"
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
            setActiveVersionIndex(parseInt(event.target.value, 10))
          }
          options={versions.map((version, index) => (
            <option
              // eslint-disable-next-line react/no-array-index-key
              key={`offer-product-version-text-${index}`}
              value={index}
            >
              {version.name}
              {version.isPrimary
                ? ` (${t(`${translations.calculationWindow}:primary`)})`
                : ''}
            </option>
          ))}
          required
          value={activeVersionIndex}
        />
        <TextInputField
          disabled={locked}
          id="offer-product-version-name"
          label={t(`${translations.common}:Name`)}
          name="offer-product-version-name"
          onChange={onVersionNameChange}
          required
          value={versions[activeVersionIndex].name}
        />
      </div>
      <OfferText
        locked={locked}
        offerText={offerText}
        onOfferTextChanged={onOfferTextChanged}
      />
    </>
  );
};

export default Version;
